// /company/{companyId}/programs/{programId}/features/tasker
import { convertTimestampToLuxonOrDefaultNow } from "../../utils/convertTimestampToLuxonOrDefaultNow";
export const isCustomRejectOption = (rejectOption) => ["custom", "custom-hidden"].includes(rejectOption.type);
export const isVisibleRejectOption = (rejectOption) => ["visible", "custom"].includes(rejectOption.type);
export function assertTaskerConfig(taskerConfig, mode = "load") {
    if (!taskerConfig || typeof taskerConfig !== "object") {
        throw new Error("TaskerConfig must be an object");
    }
    return true;
}
export const createTaskerConfigConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(taskerConfig) {
        if (!assertTaskerConfig(taskerConfig, "save")) {
            throw new Error("TaskerConfig.save failed");
        }
        const { id, programId, ...rest } = taskerConfig;
        const data = {
            ...rest,
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(taskerConfig.createdAt),
            updatedAt: convertToFirestoreTimestampOrDefaultServerTime(taskerConfig.updatedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const taskerConfig = {
            ...data,
            id: snapshot.id,
            programId: snapshot.ref.parent.parent?.id,
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            updatedAt: convertTimestampToLuxonOrDefaultNow(data.updatedAt),
        };
        if (!assertTaskerConfig(taskerConfig)) {
            throw new Error("TaskerConfig.load failed");
        }
        return taskerConfig;
    },
});
//# sourceMappingURL=TaskerConfig.js.map